import { memo, useEffect } from 'react'

import { InnosErrorBoundary } from '@inno-tools/container-bridge'
import { useMountApp } from 'modules/app-registry/hooks/useMountApp'
import { useTranslation } from 'react-i18next'
import { logger } from 'shared/services/logger'

import { WidgetAppTemplateProps } from './WidgetAppTemplate.types'

const WidgetAppTemplateContent = memo((props: WidgetAppTemplateProps) => {
  const { appProps, appName, url, scope, entryPath, envKey, user, cdnUrl } =
    props
  const { t } = useTranslation()

  const { ref, isError } = useMountApp(
    {
      url,
      scope,
      entryPath,
      envKey,
      cdnUrl
    },
    appProps
  )

  useEffect(() => {
    if (isError) {
      logger.error('federation.widget_load_failed', {
        appName,
        message: t('common.loadingError', { appName })
      })
    }
  }, [appName, isError, t])

  if (!user || user?.user_roles?.includes('anonymous')) {
    return null
  }

  return <div ref={ref} />
})

const WidgetAppTemplate = (props: WidgetAppTemplateProps) => {
  return (
    <InnosErrorBoundary debugName={`WidgetAppTemplate-${props.appName}`}>
      <WidgetAppTemplateContent {...props} />
    </InnosErrorBoundary>
  )
}

WidgetAppTemplate.displayName = 'WidgetAppTemplate'

export { WidgetAppTemplate }
